"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackFlowStarted = trackFlowStarted;
exports.trackFlowCompleted = trackFlowCompleted;
exports.trackFlowStepCompleted = trackFlowStepCompleted;
exports.trackFlowStepViewed = trackFlowStepViewed;
exports.trackFlowStepSkipped = trackFlowStepSkipped;
exports.default = void 0;

var _trackingHelper = require("../trackingHelper");

/* eslint-disable camelcase */
function trackFlowStarted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Started', payload);
}

function trackFlowCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Completed', payload);
}
/**
 * The set of all properties sent to Segment
 */


/**
 * Note: this method must be sent to ensure correct funnel analysis of user behavior
 */
function trackFlowStepCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Completed', payload);
}
/**
 * Note: this method is not used to analyse user drop-off. Be sure to send trackFlowStepCompleted
 */


function trackFlowStepViewed(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Viewed', payload);
}

function trackFlowStepSkipped(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Skipped', payload);
}

var _default = {
  trackFlowCompleted: trackFlowCompleted,
  trackFlowStarted: trackFlowStarted,
  trackFlowStepCompleted: trackFlowStepCompleted,
  trackFlowStepSkipped: trackFlowStepSkipped,
  trackFlowStepViewed: trackFlowStepViewed
};
exports.default = _default;